import moment from 'moment';//时间
import { $api } from '@/config/api';
import OSS from 'ali-oss';

// 处理为oss的链接
export const ossContent = (fileKey) => {
    // console.log('fileKey------->',fileKey)
  	// 1. 从后端获取STS临时凭证
		let stsData = JSON.parse(localStorage.getItem('oss'))

    if (fileKey.indexOf('file.marathonbm.com') != -1
     || fileKey.indexOf("marathon-image.hpaopao.com") != -1 
        || fileKey.indexOf("static.hpaopao.com") != -1 
        || fileKey.indexOf("marathon-web.hpaopao.com") != -1 
      || fileKey.indexOf("paopao-image.hpaopao.com") != -1 
      || fileKey.indexOf("psq-img.hpaopao.com") != -1) {
      let a = ''
      let bucket = 'marathon-bm-file'
      let domain = 'https://file.marathonbm.com'
     	if (fileKey.indexOf('file.marathonbm.com') != -1) {
			a = fileKey.split('https://file.marathonbm.com/')
			bucket = 'marathon-bm-file'
			domain = 'https://file.marathonbm.com'
		} else if (fileKey.indexOf("marathon-image.hpaopao.com") != -1) {
			a = fileKey.split('https://marathon-image.hpaopao.com/')
			bucket = 'marathon-image'
			domain = 'https://marathon-image.hpaopao.com'
		} else if (fileKey.indexOf("static.hpaopao.com") != -1) {
			a = fileKey.split('https://static.hpaopao.com/')
			bucket = 'marathon-webs'
			domain = 'https://static.hpaopao.com'
		} else if (fileKey.indexOf("marathon-web.hpaopao.com") != -1) {
			a = fileKey.split('https://marathon-web.hpaopao.com/')
			bucket = 'marathon-webs'
			domain = 'https://marathon-web.hpaopao.com'
		} else if (fileKey.indexOf("paopao-image.hpaopao.com") != -1) {
			a = fileKey.split('https://paopao-image.hpaopao.com/')
			bucket = 'paopao-image'
			domain = 'https://paopao-image.hpaopao.com'
		} else if (fileKey.indexOf("psq-img.hpaopao.com") != -1) {
			a = fileKey.split('https://psq-img.hpaopao.com/')
			bucket = 'psq-image'
			domain = 'https://psq-img.hpaopao.com'
		}



      if (stsData) {
        const client = new OSS({
          accessKeyId: stsData.accessKeyId, // 建议使用临时凭证或子账号密钥
          accessKeySecret: stsData.accessKeySecret,
          stsToken: stsData.securityToken,
          bucket: bucket,
          region: 'oss-cn-beijing', // 你的Bucket所在区域
          endpoint: domain, 
				  cname: true,
          // endpoint: 'http://files-test.marathonbm.com',
        });

    

        const url = client.signatureUrl(a[1], {
          expires: 3600 // 设置URL有效期为3600秒（单位：秒）
        });
        // console.log(url)

        let array = ['982285707324166266', '982285927139250176', '982285927139250181', '982285927139250186',
					'982285927139250178'
				]
        var randomIndex = Math.floor(Math.random() * array.length);
				var srcNumber = array[randomIndex];
        return `${url}&requestId=${srcNumber}`
      // } else {
      //   return fileKey;
      // }
    } else {
      return fileKey;
    }
  }
}

/* 中国标准时间 转 正常时间 */
export const FORMATTIME = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : ''
}

export const handleHoverImg = () => {
  // 获取页面上hoverImg下所有的img
  var imageSrc = document.querySelectorAll('.hoverImg img')
  if (imageSrc && imageSrc.length) {
    imageSrc.forEach(item => {
      item.src = handleSrcContent(decodeURIComponent(item.src))
    })
  }
  console.log(imageSrc)
  return imageSrc
}


export const handleZoomImg = () => {
  var imageSrc = document.querySelector('.zoomImg')
  if (imageSrc && imageSrc.src) {
    imageSrc.src = handleSrcContent(imageSrc.src)
      console.log('----->',imageSrc.src)

  }

  return imageSrc
}

/**
 * 修改HTML中所有表格相关元素的样式，保留并合并原有样式
 * @param {string} html - 原始HTML字符串
 * @param {Object} styles - 要添加/覆盖的样式配置
 * @returns {string} 处理后的HTML字符串
 */
function enhanceTableStyles(html, styles = {}) {
  // 默认样式配置
  const defaultStyles = {
    table: 'border-collapse: collapse;border-spacing: 0;',
    tr: 'border: 1px solid #333;',
    th: 'border: 1px solid #333;background:#f5f2f0;',
    td: 'border: 1px solid #333;'
  };

  // 合并用户自定义样式和默认样式
  const mergedStyles = { ...defaultStyles, ...styles };

  // 更健壮的正则表达式，处理复杂属性
  const tagRegex = (tagName) =>
    new RegExp(`<${tagName}\\b((?:[^>"']|"[^"]*"|'[^']*')*)>`, 'gi');

  // 合并样式字符串
  const mergeStyles = (existingStyle, newStyle) => {
    if (!existingStyle) return newStyle;

    const styleMap = {};

    // 将现有样式转换为对象
    existingStyle.split(';').forEach(declaration => {
      const [prop, value] = declaration.split(':').map(s => s.trim());
      if (prop && value) styleMap[prop] = value;
    });

    // 添加/覆盖新样式
    newStyle.split(';').forEach(declaration => {
      const [prop, value] = declaration.split(':').map(s => s.trim());
      if (prop && value) styleMap[prop] = value;
    });

    // 转换回样式字符串
    return Object.entries(styleMap)
      .map(([prop, value]) => `${prop}: ${value}`)
      .join('; ');
  };

  // 处理单个标签类型
  const processTag = (html, tagName, newStyle) => {
    return html.replace(
      tagRegex(tagName),
      (match, attributes) => {
        // 提取现有style属性
        let existingStyle = '';
        let cleanedAttrs = attributes.replace(
          /\s+style\s*=\s*(["'])((?:(?!\1).)*)\1/i,
          (_, quote, style) => {
            existingStyle = style;
            return '';
          }
        ).trim();

        // 合并样式
        const mergedStyle = mergeStyles(existingStyle, newStyle);

        // 重建属性字符串
        const styleAttr = cleanedAttrs
          ? ` ${cleanedAttrs} style="${mergedStyle}"`
          : ` style="${mergedStyle}"`;

        return `<${tagName}${styleAttr}>`;
      }
    );
  };

  // 处理各种表格相关标签
  let result = html;
  for (const [tagName, style] of Object.entries(mergedStyles)) {
    result = processTag(result, tagName, style);
  }

  return result;
}


export const handleSetHtml = (value, flag) => {
  console.log('处理富文本数据---->', value, flag)
  // 正则表达式匹配所有的img标签
  let imgRegex = /<img[^>]+src="([^">]+)"/g;
  let imageRegex = /<image[^>]+src="([^">]+)"/g;
  let videoRegex = /<video[^>]+src="([^">]+)"/g;

  // 使用正则表达式找到所有的图片链接
  let matchs = [];

  while ((matchs = imgRegex.exec(value)) !== null) {
    let newSrc = ''
    console.log('matchs[1]----->', matchs[1])

    if (flag == 'edit') {
      // 详情的时候使用
      newSrc = handleSrcContent(matchs[1]);
    } else {
      // 提交的时候使用
      newSrc = handleDelContent(matchs[1]);
    }

    value = value.replace(matchs[1], newSrc);

  }
  while ((matchs = imageRegex.exec(value)) !== null) {
    let newSrc = ''

    if (flag == 'edit') {
      // 详情的时候使用
      newSrc = handleSrcContent(matchs[1]);
    } else {
      // 提交的时候使用
      newSrc = handleDelContent(matchs[1]);
    }

    value = value.replace(matchs[1], newSrc);
  }

  while ((matchs = videoRegex.exec(value)) !== null) {
    let newSrc = ''

    if (flag == 'edit') {
      // 详情的时候使用
      newSrc = handleSrcContent(matchs[1]);
    } else {
      // 提交的时候使用
      newSrc = handleDelContent(matchs[1]);
    }

    value = value.replace(matchs[1], newSrc);
  }

  return enhanceTableStyles(value)
}



export const handleDelContent = (url) => {
  let urlArr = []
  let urls = []
  let typeofUrl = 'string'

  if (url) {
    if (typeof url === 'string') {
      typeofUrl = 'string'
      // 处理原始数据----->
      urlArr = url.split(',')
    } else {
      typeofUrl = 'array'
      urlArr = url
    }
    urlArr.map(item => {
      
      if (item.indexOf('?OSSAccessKeyId=') != -1) {
        item = decodeURIComponent(item)
        if (item.indexOf('?') !== -1) {
          // 有问号
          urls.push(`${item.split('?OSSAccessKeyId=')[0]}`)

        } else {
          // 没有问号
          urls.push(`${item.split('&OSSAccessKeyId=')[0]}`)
        }

        // 域名 https://marathon-bm-file.oss-cn-beijing.aliyuncs.com
      } else {
        urls.push(item)
      }
    })
  }

  if (typeofUrl == 'string') {
    return urls.toString()
  } else {
    return urls
  }
}



// 加密为oss
export const handleSrcContent = (url) => {
  let urlArr = []
  let urls = []
  let typeofUrl = 'string'
  if (url) {
    if (typeof url === 'string') {
      typeofUrl = 'string'
      // 处理原始数据----->
      urlArr = url.split(',')
    } else {
      typeofUrl = 'array'
      urlArr = url
    }
    // 判断域名只要是这些 就需要处理位oss
    urlArr.map(item => {
      if ((item.indexOf('file.marathonbm.com') != -1 
      || item.indexOf("marathon-image.hpaopao.com") != -1 
      || item.indexOf("static.hpaopao.com") != -1 
      || item.indexOf("marathon-web.hpaopao.com") != -1 
      || item.indexOf("paopao-image.hpaopao.com") != -1 
      || item.indexOf("psq-img.hpaopao.com") != -1)) {
        if (item.indexOf('?') !== -1) {
          // urls.push(`${item}&requestId=${srcNumber}`)
          let a = item.split('?')
          urls.push(ossContent(a[0]))

        }else{
          urls.push(ossContent(item))
        }
        
      } else {
        urls.push(item)
      }
    })
  }
  // console.log('返回的数据---->',urls)


  if (typeofUrl == 'string') {
    return urls.toString()
  } else {
    return urls
  }
}





/* 中国标准时间/毫秒值 转 正常时间 带时分秒 */
export const TIMEFORMATmin = (msec) => {
  let datetime = new Date(msec);
  // console.log(' 自定义时间转换 ', datetime)
  let year = datetime.getFullYear();
  let month = datetime.getMonth();
  let date = datetime.getDate();
  let hour = datetime.getHours();
  let minute = datetime.getMinutes();
  let second = datetime.getSeconds();

  let result1 = year +
    '-' +
    ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
    '-' +
    ((date + 1) <= 10 ? '0' + date : date) +
    ' ' +
    ((hour + 1) <= 10 ? '0' + hour : hour) +
    ':' +
    ((minute + 1) <= 10 ? '0' + minute : minute) +
    ':' +
    ((second + 1) <= 10 ? '0' + second : second);


  return result1;
}


export const expressData = [
  {
    value: '顺丰速运',
    label: 'SF'
  },
  {
    value: '圆通快递',
    label: 'YTO'
  },
  {
    value: '圆通承诺达',
    label: 'CP468398'
  },
  {
    value: '韵达快递',
    label: 'YUNDA'
  },
  {
    value: '韵达快运',
    label: 'YDKY'
  },
  {
    value: '韵达同城',
    label: 'LE10032270'
  },
  {
    value: '中通快递',
    label: 'ZTO'
  },
  {
    value: '中通快运',
    label: 'ZTOKY'
  },
  {
    value: '申通快递',
    label: 'STO'
  },
  {
    value: '申通快运',
    label: 'STOKY'
  },
  {
    value: '百世快递',
    label: 'HTKY'
  },
  {
    value: '百世快运',
    label: 'BESTQJT'
  },
  {
    value: '百世云配',
    label: 'CP443514'
  },
  {
    value: '极兔快递',
    label: 'JT'
  },
  {
    value: '丰网速运',
    label: 'FW'
  },
  {
    value: '中国邮政',
    label: 'EMS'
  },
  {
    value: '邮政国际包裹',
    label: 'CNPOSTGJ'
  },
  {
    value: 'EMS国际',
    label: 'EMSGJ'
  },
  {
    value: '京东快递',
    label: 'JD'
  },
  {
    value: '德邦快递',
    label: 'DBKD'
  },
  {
    value: '德邦物流',
    label: 'DBL'
  },
  {
    value: '德邦快运',
    label: 'DBKY'
  },
  {
    value: '天天快递',
    label: 'TTKDEX'
  },
  {
    value: '宅急送',
    label: 'ZJS'
  },
  {
    value: '联邦快递',
    label: 'FEDEX'
  },
  {
    value: '苏宁快递',
    label: 'SNWL'
  },
  {
    value: '丹鸟',
    label: 'ZMKM'
  },
  {
    value: 'DHL中国',
    label: 'DHLCN'
  }
]



/* 中国标准时间/毫秒值 转 正常时间 不带时分秒 */
export const TIMEFORMAT = (msec) => {
  let datetime = new Date(msec);
  // console.log(' 自定义时间转换 ', datetime)
  let year = datetime.getFullYear();
  let month = datetime.getMonth();
  let date = datetime.getDate();

  let result2 = year +
    '-' +
    ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
    '-' +
    ((date + 1) < 10 ? '0' + date : date);

  return result2;
}


// 校验两位小数
export const getTofixed = (numBer) => {
  let num = Number(numBer.toString().match(/^\d+(?:\.\d{0,2})?/));
  return num
}


// 销毁标签所存储的内容
export const closeParam = (val) => {
  let arr = localStorage.getItem('params') ? JSON.parse(localStorage.getItem('params')) : []
  console.log('存储---', arr)

  if (arr.length) {
    let isItem = arr.find(item => {
      return item.url == val
    })

    if (isItem) {
      let index = arr.findIndex(item => {
        return item.url == val
      })
      arr.splice(index, 1)
      console.log('index----', index, arr)

    }
    localStorage.setItem('params', arr ? JSON.stringify(arr) : [])

    console.log('是否有存储内容 并 销毁标签-----', isItem, arr)
  }


}

// 返回
export const goBack = (path, NS, navigate) => {
  let arr = []
  let list = []

  JSON.parse(sessionStorage.getItem('navigateList')).map((item, index) => {
    console.log('数据-----', item.path, window.location.pathname.slice(1, window.location.pathname.length))
    if (item.path == window.location.pathname.slice(1, window.location.pathname.length)) {
      console.log('相同数据-----', item)
      localStorage.getItem('path')?.split(',')?.map(item => {
        NS.delList(`/${item.path}${window.location.search}`)
      })
    } else {
      list.push(item)
    }
  })
  localStorage.getItem('path')?.split(',')?.map((item, index) => {
    if (item.split('?')[0] == window.location.pathname) {

    } else {
      arr.push(item)
    }
  })
  NS.navigateList = list
  sessionStorage.setItem('navigateList', JSON.stringify(list))
  console.log('最终的数据-----', arr, list)
  localStorage.setItem('path', arr.toString())
  localStorage.setItem('flagPath', true)

  navigate(path)
  localStorage.removeItem('flagPath')
}



// 没有数据的情况转化为0.00
// 有数据处理为两位小数
// 并且由分转换为元
export const NB = (v) => {
  return v ? (Number(v) * 0.01).toFixed(2) : '0.00'
}

// 没有数据的情况转化为0.00
// 有数据处理为两位小数
// 元
export const NY = (v) => {
  return v ? Number(v).toFixed(2) : '0.00'
}

export const ND = (val) => {
  return (val ?? '') !== '' ? val : '--';
}


// 详情展示 日期转换（数组）
export const dateArray = (val1, val2) => {
  return [moment(val1), moment(val2)]
}
// 详情展示 format日期转换（字符串）
export const formatString = (val1) => {
  return `${moment(val1).format('YYYY-MM-DD HH:mm:ss')}`

}

// 详情展示 format日期转换（数组）
export const formatArray = (val1, val2) => {
  let a = [`${formatString(val1)}` - `${formatString(val2)}`]
  return a
}



// 详情展示 日期转换（字符串-无默认）
export const dateString = (val1) => {
  return val1 ? moment(val1) : null
}
// 详情展示 日期转换（字符串-有默认）
export const dateStringD = (val1) => {
  return val1 ? moment(val1) : moment(moment().format(), 'YYYY-MM-DD')
}